import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { BlankPage, Loading, Nav, LBlist, LBdetail, Hint } from "@/components";
import { Reconciliation, Common } from "@/constant";
import { DepositModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { UserInfo } from "@/types/Login";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";
import { Util } from "@/util/Util";

// 特店 - 子項目 (每個特店資訊)
type Store = {
    id: number;
    code: string;
    name: string;
    selected: boolean;
};

// 特店 - 主項目 (統編號碼 + 全選)
type StoreGroup = {
    tidNumber: string;
    selected: boolean;
    storeList: Store[];
};

@Component<ReconciliationDepositController>({
    components: {
        BlankPage,
        Nav,
        Loading,
        LBlist,
        LBdetail,
        Hint,
    },
})
export default class ReconciliationDepositController extends Vue {
    private isLoading = true; // 控制顯示header

    // 搜尋引擎 - 空用元件
    private expireTime = 0;    
    private periodMap = Reconciliation.PeriodMap;
    private saleKindMap = Reconciliation.SaleKindMap;
    private minDate = "";
    private maxDate = "";

    private searchItem: {
        storeType: number;
        tidNumber: string;
        storeArr: string[];
        periodType: number;
        start: string;
        end: string;
        saleKindType: number;
        account: string;
    } = {
            storeType: 0,
            tidNumber: "",
            storeArr: [],
            periodType: 1,
            start: "",
            end: "",
            saleKindType: 0,
            account: "",
        };
    private datePeriodStartMax = "";

    private tidNumberArr:string[] = [];

    // 選取特約清單 => 是否展開LB
    private storeGroupList: StoreGroup[] = [];
    private isOpenStoreLB = false;

    // filter => 依特店彙總, 依入帳號彙總
    private filterType = "store";

    // 列表
    private reconciliationList: TCBReceiptApi.Protobuf.IReconciliation[] = [];
    private reimbursementTotal = TCBReceiptApi.Protobuf.ReimbursementTotal.create();
    private saleShowMap: { [key: number]: string } = {
        1: '一般',
        2: '境外',
    };
    // 列表 - 依特店彙總
    private byStoreMap: { [k: string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};
    // 列表 - 依入帳彙總
    private byAccountMap: { [k: string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};
    // 列表 - 新版 - 依不同入帳彙總
    private byDiffAccountMap: { [k: string]: { [k:string]: TCBReceiptApi.Protobuf.DepositInfo[] } } = {};
    // 統計
    private totalObj = TCBReceiptApi.Protobuf.DepositTotal.create();

    // 展開收合
    private isUnfold = false;
    private unfoldList: string[] = [];

    // 展開明細
    private showAllList: string[] = [];

    // 查看明細 => 是否展開LB
    private isOpenDetailLB = false;

    // 入帳帳號map
    private accountMapByStore: { [storeCode: string]: string } = {};
    private accountMapByAccount: { [storeCode: string]: string } = {};
    private accountMapByDiffAccount: { [account: string]: string } = {}; // 入帳帳號 配對 入帳分行

    // LB
    private hintBox: { show: boolean, msg: string } = { show: false, msg: "" };

    // 屬於該帳號下的統編 => 用來取得特店清單
    private tidNumber = "";

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
        this.tidNumber = userInfo.identification as string;
        console.log(this.tidNumber);

        const day = new Date();
        this.searchItem.end = day.toISOString().split("T")[0];
        this.datePeriodStartMax = day.toISOString().split("T")[0];
        this.searchItem.start = day.toISOString().split("T")[0];

        /* sample data */
        // this.searchItem.start =  "2020-12-22";
        // this.searchItem.end = "2020-12-22";
        /* sample data */

        this.isLoading = false;

        localStorage.removeItem("FrontReconciliationDeposit");
    }

    /* 選取特店清單LB */
    // 取得特店清單
    private async getStoreList(tidNumber: string) {
        const item = TCBReceiptApi.Protobuf.StoreInsertQuery.create({
            type: TCBReceiptApi.Protobuf.StoreInsertQueryType.SIQT_TID_NUMBER,
            identification: tidNumber,
        });

        const storeInsertQuery = TCBReceiptApi.Protobuf.StoreInsertQuery.encode(
            item
        ).finish();
        await DepositModel.getStoreSearch(storeInsertQuery);

        /* 取得該帳號下的特店清單 */
        const storeUserPermissionMap = DepositModel.getStoreList().map;
        console.log("StoreUserPermissionMap");
        console.log(storeUserPermissionMap);

        Object.keys(storeUserPermissionMap).forEach(thisTidNumber => {
            const rawSearchList = storeUserPermissionMap[thisTidNumber] as TCBReceiptApi.Protobuf.StoreUserPermissionList;
            // 組成map傳至LB給component使用
            const storeList: Store[] = [];

            rawSearchList.list.forEach((thisStore: any) => {
                const store: Store = {
                    id: thisStore.storeId as number,
                    code: thisStore.storeCode as string,
                    name: thisStore.registerName?.trim() as string,
                    selected: true,//預設全選
                };

                storeList.push(store);
            });

            const storeGroup: StoreGroup = {
                tidNumber: thisTidNumber,
                selected: true,//預設全選
                storeList: storeList,
            };

            this.storeGroupList.push(storeGroup);
        });
        /* 取得該帳號下的特店清單 */
    }

    private closeLBlist() {
        this.isOpenStoreLB = false;
    }

    private selectStore(type: number, tidNumber: string, storeArr: string[], tidNumberArr: string[]) {
        this.searchItem.storeType = type;
        this.searchItem.tidNumber = tidNumber;
        this.searchItem.storeArr = storeArr;
        this.tidNumberArr = tidNumberArr;

        this.isOpenStoreLB = false;
    }
    /* 選取特店清單LB */

    /* 起訖日期 */
    private bindDateType() {
        if (String(this.searchItem.periodType) === "2") {
            // 調整日期的起訖
            const day = new Date();
            this.searchItem.end = day.toISOString().split("T")[0];
            day.setDate(day.getDate() - 7);
            this.searchItem.start = day.toISOString().split("T")[0];
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        } else if (String(this.searchItem.periodType) === "3") {
            // 調整日期的起訖
            const day = new Date();
            this.searchItem.end = day.toISOString().split("T")[0];
            day.setDate(day.getDate() - 31);
            this.searchItem.start = day.toISOString().split("T")[0];
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        } else {
            const day = new Date();
            this.datePeriodStartMax = day.toISOString().split("T")[0];
        }
    }

    private bindDatePeriod() {
        if (String(this.searchItem.periodType) === "2") {
            // 調整日期的起訖
            const day = new Date(this.searchItem.start);
            this.searchItem.start = day.toISOString().split("T")[0];
            day.setDate(day.getDate() + 7);
            this.searchItem.end = day.toISOString().split("T")[0];
        } else if (String(this.searchItem.periodType) === "3") {
            // 調整日期的起訖
            const day = new Date(this.searchItem.start);
            this.searchItem.start = day.toISOString().split("T")[0];
            day.setDate(day.getDate() + 31);
            this.searchItem.end = day.toISOString().split("T")[0];
        }

        const day = new Date(this.searchItem.start);

        if (
            new Date(this.searchItem.start).getTime() >
            new Date(this.searchItem.end).getTime()
        ) {
            this.searchItem.end = this.searchItem.start;
        }

        this.minDate = day.toISOString().split("T")[0];
        day.setDate(day.getDate() + 31);
        this.maxDate = day.toISOString().split("T")[0];

        if (
            (new Date(this.searchItem.end).getTime() - new Date(this.searchItem.start).getTime()) >= 86400 * 31 * 1000
        ) {
            this.searchItem.end = day.toISOString().split("T")[0];
        }
    }
    /* 起訖日期 */

    /* LB */
    private openHint(msg: string) {
        this.hintBox.msg = msg;
        this.hintBox.show = true;
    }
    private closeHint() {
        this.hintBox.msg = "";
        this.hintBox.show = false;
    }
    /* LB */

    /* 搜尋 */
    private validCondition(): boolean {
        // 沒有選取特店
        if (this.searchItem.storeType === 0) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.RequireStore]);
            return false;
        }

        if (this.searchItem.start === "" || this.searchItem.end === "") {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.RequireDate]);
            return false;
        }

        // 無法查詢未來時間
        const startUnix = new Date(this.searchItem.start).getTime();
        const endUnix = new Date(this.searchItem.end).getTime();
        const dUnix = new Date().getTime(); // today unix
        if ((startUnix > dUnix) || (endUnix > dUnix)) {
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.DatePeriodError]);
            return false;
        }

        return true;
    }

    private async searchByCondition() {
        if (!this.validCondition()) {
            return false;
        }

        if (!Util.passReconciliationByCookie()) {
            return;
        }

        this.isLoading = true;

        // 整理input
        const item = TCBReceiptApi.Protobuf.DepositQuery.create();
        item.storeList = this.searchItem.storeArr; // 特店清單 - 輸入"特店代號""
        item.tidNumber = this.searchItem.tidNumber;
        item.dateStart = this.searchItem.start; // 起
        item.dateEnd = this.searchItem.end; // 訖
        item.account = this.searchItem.account; // 入帳帳號
        item.type = this.searchItem.saleKindType; // 業務種類

        console.log("item");
        console.log(item);

        /* 寫入 local storage 方便列印 */
        const storageItem: {
            filterType: string,
            search: TCBReceiptApi.Protobuf.DepositQuery,
        } = {
            filterType: this.filterType,
            search: item,
        }
        localStorage.setItem("FrontReconciliationDeposit", JSON.stringify(storageItem));
        /* 寫入 local storage 方便列印 */

        const depositQuery = TCBReceiptApi.Protobuf.DepositQuery.encode(
            item
        ).finish();

        /* init */
        this.init();
        /* init */        

        /* 取得列表 */
        await DepositModel.getReimbursement(depositQuery);
        const reimbursementList = DepositModel.getReimbursementList();
        this.reconciliationList = reimbursementList.list;
        console.log("this.reconciliationList");
        console.log(this.reconciliationList);
        /* 取得列表 */

        /* 取得展開資料 - map */
        await DepositModel.getDepositCollectionMap(depositQuery);
        const depositCollectionMap: TCBReceiptApi.Protobuf.DepositCollectionMap = DepositModel.getDepositCollectionMapData();
        console.log('取得的map 需要展開的資料 depositCollectionMap');
        console.log(depositCollectionMap);
        console.log('丟入整理小計');
        this.countTotalFromMap(depositCollectionMap.map);
        console.log('----------- 依特店彙總Map');
        console.log(this.byStoreMap);
        console.log('----------- 依帳號彙總Map');
        console.log(this.byAccountMap);

        // 第一次預先展開
        this.unfoldList = [];
        Object.keys(depositCollectionMap.map).forEach((thisStoreCode) => {
            this.unfoldList.push(thisStoreCode);
        });
        console.log("unfoldList");
        console.log(this.unfoldList);
        /* 取得展開資料 - map */

        /* 取得統計 */
        await DepositModel.getDepositTotal(depositQuery);
        const depositTotal = DepositModel.getDepositTotalData();
        console.log('depositTotal');
        console.log(depositTotal);
        this.totalObj = depositTotal;
        /* 取得統計 */

        this.isLoading = false;

        console.log("accountMapByStore");
        console.log(this.accountMapByStore);
        console.log("accountMapByAccount");
        console.log(this.accountMapByAccount);
    }
    /* 搜尋 */

    /* filter => 依特店彙總, 依入帳號彙總 */
    private async changeFilter(type: string) {
        this.filterType = type;

        /* 寫入 local storage 方便列印 */
        const reconciliationDepositJson = localStorage.getItem("FrontReconciliationDeposit") as string;
        if (reconciliationDepositJson && reconciliationDepositJson !== "") {
            const reconciliationDeposit = JSON.parse(reconciliationDepositJson) as { filterType: string, search: TCBReceiptApi.Protobuf.DepositQuery };

            const storageItem: {
                filterType: string,
                search: TCBReceiptApi.Protobuf.DepositQuery,
            } = {
                filterType: type,
                search: reconciliationDeposit.search,
            }
            localStorage.setItem("FrontReconciliationDeposit", JSON.stringify(storageItem));
        }
        /* 寫入 local storage 方便列印 */
    }
    /* filter => 依特店彙總, 依入帳號彙總 */

    /* 展開收合 */
    private checkIsUnfold(storeCode: string) {
        let isUnfold = false;
        this.unfoldList.some((thisStoreCode) => {
            if (thisStoreCode === storeCode) {
                isUnfold = true;
                return true;
            }
        });
        return isUnfold;
    }

    private async foldAndUnfoldItem(storeCode: string) {
        const isExist = this.unfoldList.findIndex(
            (thisStoreCode) => thisStoreCode === storeCode
        );
        console.log("isExist");
        console.log(isExist);

        if (isExist >= 0) {
            // 已經展開
            this.unfoldList.splice(isExist, 1);
        } else {
            // 判斷map是否有對應資料, 有 => 直接加入展開列表, 否 => 動態拿資料回來顯示
            if (!this.byStoreMap[storeCode]) {
                console.log("map no data");
                // 整理input
                const item = TCBReceiptApi.Protobuf.DepositQuery.create();
                item.account = this.searchItem.account; // 入帳帳號
                item.type = this.searchItem.saleKindType; // 業務種類
                item.dateStart = this.searchItem.start; // 起
                item.dateEnd = this.searchItem.end; // 訖
                item.specificStore = storeCode; // 單一特店

                const depositQuery = TCBReceiptApi.Protobuf.DepositQuery.encode(
                    item
                ).finish();

                /* 取得展開資料 */
                await DepositModel.getDepositCollection(depositQuery);
                const depositCollection = DepositModel.getDepositCollectionData();
                console.log("depositCollection");
                console.log(depositCollection);

                const mapItem: { [k: string]: TCBReceiptApi.Protobuf.DepositCollection } = {};
                mapItem[storeCode] = depositCollection;
                this.countTotalFromMap(mapItem);
                /* 取得展開資料 */
            }

            this.unfoldList.push(storeCode);
        }
    }
    /* 展開收合 */

    /* 查看明細 */
    private openDetailLB(index: number) {
        console.log(index);
        this.isOpenDetailLB = true;
    }

    private closeLBdetail() {
        this.isOpenDetailLB = false;
    }
    /* 查看明細 */

    /* 其他 */
    private isNotNatureNum(val: string) {
        if (val) {
            const num = (val + "").replace(/,/g, "");
            return Number(num) <= 0;
        } else {
            return false;
        }
    }

    // 數字轉千分位 (number to string) ps.保留數字小數點至第二位
    private convertNumberToMoney(num: number) {
        if (!num) {
            return 0;
        }
        let a: string = (num + "").replace(/,/g, "");
        if (a.indexOf(".") != -1) {
            if (a.split(".")[1].length > 2) {
                a = Math.round(+a * 100) / 100 + "";
            }
            if (a.split(".").length == 2) {
                return (+a.split(".")[0]).toLocaleString() + "." + a.split(".")[1];
            } else {
                return (+a.split(".")[0]).toLocaleString();
            }
        } else {
            return (+a.split(".")[0]).toLocaleString();
        }
    }

    // 統計 小計與合計等等資料
    private countTotalFromMap(storeCodeMap: { [k: string]: TCBReceiptApi.Protobuf.IDepositCollection }) {
        if (storeCodeMap) {
            Object.keys(storeCodeMap).forEach(thisStoreCode => {
                console.log(thisStoreCode);

                /* 依特店彙總 */
                // 遍歷每一個特店
                const storeInfoList: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                // 合計
                const storeTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });

                // 依特店彙總
                const storeDateMenu = storeCodeMap[thisStoreCode].byStore as TCBReceiptApi.Protobuf.DepositDateMap;
                if (storeDateMenu) {
                    const dateMap = storeDateMenu.byDate as { [k: string]: TCBReceiptApi.Protobuf.Deposit };
                    if (dateMap) {
                        Object.keys(dateMap).forEach(thisDate => {
                            // 小計
                            const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                            const infoList = dateMap[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                            infoList.forEach(thisInfo => {
                                // 彙總
                                storeInfoList.push(thisInfo);
                                // 小計
                                subTotalItem.amount += (thisInfo.amount as number);
                                subTotalItem.charge += (thisInfo.charge as number);
                                subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                subTotalItem.netAmount += (thisInfo.netAmount as number);
                                // 合計
                                storeTotalItem.amount += (thisInfo.amount as number);
                                storeTotalItem.charge += (thisInfo.charge as number);
                                storeTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                storeTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                storeTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                storeTotalItem.netAmount += (thisInfo.netAmount as number);

                                this.accountMapByStore[thisStoreCode] = thisInfo.account as string;
                            });

                            storeInfoList.push(subTotalItem);
                        });
                    }

                    // if (storeInfoList.length > 0) {
                    storeInfoList.push(storeTotalItem);

                    this.byStoreMap[thisStoreCode] = storeInfoList;
                    // }
                }
                /* 依特店彙總 */

                /* 依入帳號彙總 */
                // 遍歷每一個特店
                const accountInfoList: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                // 合計
                const accountTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });

                // 依入帳號彙總
                const accountDateMenu = storeCodeMap[thisStoreCode].byAccount as TCBReceiptApi.Protobuf.DepositDateMap;
                if (accountDateMenu) {
                    const dateMap = accountDateMenu.byDate as { [k: string]: TCBReceiptApi.Protobuf.Deposit };
                    if (dateMap) {
                        Object.keys(dateMap).forEach(thisDate => {
                            // 小計
                            const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                            const infoList = dateMap[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                            infoList.forEach(thisInfo => {
                                // 彙總
                                accountInfoList.push(thisInfo);
                                // 小計
                                subTotalItem.amount += (thisInfo.amount as number);
                                subTotalItem.charge += (thisInfo.charge as number);
                                subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                subTotalItem.netAmount += (thisInfo.netAmount as number);
                                // 合計
                                accountTotalItem.amount += (thisInfo.amount as number);
                                accountTotalItem.charge += (thisInfo.charge as number);
                                accountTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                accountTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                accountTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                accountTotalItem.netAmount += (thisInfo.netAmount as number);
                            
                                this.accountMapByAccount[thisStoreCode] = thisInfo.account as string;
                            });

                            accountInfoList.push(subTotalItem);
                        });
                    }

                    // if (accountInfoList.length > 0) {
                    accountInfoList.push(accountTotalItem);

                    this.byAccountMap[thisStoreCode] = accountInfoList;
                    // }
                }
                /* 依入帳號彙總 */

                /* 新版 - 依不同入帳號彙總 */
                const diffAccountInfoList: { [k:string]: TCBReceiptApi.Protobuf.DepositInfo[] } = {};

                if (storeCodeMap[thisStoreCode].byDiffAccount) {
                    const depositCollectionMenu = storeCodeMap[thisStoreCode].byDiffAccount as { [k:string]: TCBReceiptApi.Protobuf.DepositDateMap };
                    if (depositCollectionMenu) {
                        Object.keys(depositCollectionMenu).forEach(thisAccount => {
                            const depositDateMap = depositCollectionMenu[thisAccount] as TCBReceiptApi.Protobuf.DepositDateMap;
                            const diffAccountTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 3 });
                            if (depositDateMap) {
                                const depositMenu = depositDateMap.byDate as { [k:string]: TCBReceiptApi.Protobuf.Deposit };
                                Object.keys(depositMenu).forEach(thisDate => {
                                    // 小計
                                    const subTotalItem = TCBReceiptApi.Protobuf.DepositInfo.create({ infoType: 2 });

                                    const infoList = depositMenu[thisDate].list as TCBReceiptApi.Protobuf.DepositInfo[];
                                    infoList.forEach(thisInfo => {
                                        // 彙總
                                        const item: TCBReceiptApi.Protobuf.DepositInfo[] = [];
                                        if (!diffAccountInfoList[thisAccount]) {
                                            diffAccountInfoList[thisAccount] = item;
                                        }
                                        diffAccountInfoList[thisAccount].push(thisInfo);
                                        // 小計
                                        subTotalItem.amount += (thisInfo.amount as number);
                                        subTotalItem.charge += (thisInfo.charge as number);
                                        subTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                        subTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                        subTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                        subTotalItem.netAmount += (thisInfo.netAmount as number);
                                        // 合計
                                        diffAccountTotalItem.amount += (thisInfo.amount as number);
                                        diffAccountTotalItem.charge += (thisInfo.charge as number);
                                        diffAccountTotalItem.internalIfr += (thisInfo.internalIfr as number); // // 代收轉入
                                        diffAccountTotalItem.externalIfr += (thisInfo.externalIfr as number); // 國外代收轉入
                                        diffAccountTotalItem.chargeTotal += (thisInfo.chargeTotal as number);
                                        diffAccountTotalItem.netAmount += (thisInfo.netAmount as number);

                                        this.accountMapByDiffAccount[thisAccount] = (thisInfo.branchBankCode as string + " " + thisInfo.branchBankName as string).trim();
                                    });

                                    diffAccountInfoList[thisAccount].push(subTotalItem);
                                })
                            }
                            diffAccountInfoList[thisAccount].push(diffAccountTotalItem);
                        });
                    }
                }

                if (Object.keys(diffAccountInfoList).length > 0) {
                    this.byDiffAccountMap[thisStoreCode] = diffAccountInfoList;
                }
                /* 新版 - 依不同入帳號彙總 */
            });
            console.log("/* 新版 - 依不同入帳號彙總 */");
            console.log(this.byDiffAccountMap);
            console.log("/* 新版 - 依不同入帳號彙總 */");
        }
    }
    /* 其他 */

    /* 特店清單LB */
    private openStoreLightbox() {
        this.isOpenStoreLB = true;
        this.$emit("searchStore", this.tidNumber);
    }
    /* 特店清單LB */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }

        this.expireTime = Priv._getExpireTime();
    }
    /* 取得最新的權限map並判斷有何權限 */

    private async exportFile() {
        if (!this.validCondition()) {
            return false;
        }

        if (!Util.passReconciliationByCookie()) {
            return;
        }

        this.isLoading = true;

        const item = TCBReceiptApi.Protobuf.DepositQuery.create();
        item.storeList = this.searchItem.storeArr; // 特店清單 - 輸入"特店代號""
        item.tidNumber = this.searchItem.tidNumber;
        item.dateStart = this.searchItem.start; // 起
        item.dateEnd = this.searchItem.end; // 訖
        item.account = this.searchItem.account; // 入帳帳號
        item.type = this.searchItem.saleKindType; // 業務種類

        // 整理condition (ReimbursementQuery)
        const queryArray: string[] = [];
        const storeArr: string[] = [];
        let idx = 0;

        for(let i=0; i<this.searchItem.storeArr.length; i++)
        {
            const storecodeTxt = this.searchItem.storeArr[i].substring(3, 11);

            idx = this.tidNumberArr.indexOf(storecodeTxt);
            if(idx == -1){
                storeArr.push(this.searchItem.storeArr[i]);
            }
        }

        const storeList: string = (storeArr.length !== 0) ? ("storeList=" + JSON.stringify(storeArr)) : "storeList=";
        queryArray.push(storeList);
        const tidNumber: string = (this.tidNumberArr.length !== 0) ? ("tidNumberList=" + JSON.stringify(this.tidNumberArr)) : "tidNumberList=";
        queryArray.push(tidNumber);

        if(storeArr.length > 50){
            this.openHint(Common.ErrorCodeMap[Common.ErrorHintMap.ExportNumExceedLimit]);
            this.isLoading = false;
            return false;
        }

        const dateStart: string = (this.searchItem.start !== "") ? ("dateStart=" + this.searchItem.start) : "dateStart=";
        queryArray.push(dateStart);
        const dateEnd: string = (this.searchItem.end !== "") ? ("dateEnd=" + this.searchItem.end) : "dateEnd=";
        queryArray.push(dateEnd);
        const account: string = (this.searchItem.account !== "") ? ("account=" + this.searchItem.account) : "account=";
        queryArray.push(account);
        const type: string = (this.searchItem.saleKindType !== 0) ? ("type=" + this.searchItem.saleKindType) : "type=";
        queryArray.push(type);

        // tabType: { 1: "依特店彙總", 2: "依入帳帳號彙總" }
        let tab = 0;
        switch (this.filterType) {
            case "store":
                tab = 1;
                break;
            case "account":
                tab = 2;
                break;
        }
        const tabType: string = (tab !== 0) ? ("tabType=" + tab) : "tabType=";
        queryArray.push(tabType);

        console.log("queryArray");
        console.log(queryArray);
        const queryString = (queryArray.length === 0) ? "" : queryArray.join("&") as string;
        console.log("queryString");
        console.log(queryString);

        await DepositModel.exportDeposit(queryString);

        this.isLoading = false;
    }

    private init() {
        this.byStoreMap = {};
        this.byAccountMap = {};
        this.byDiffAccountMap = {};
    }    
}
